// The backend escapes these six on write; &amp; must decode last so `&amp;lt;` stays `&lt;`.
const ENTITIES: [RegExp, string][] = [
  [/&#x2F;/g, '/'],
  [/&#x27;/g, "'"],
  [/&quot;/g, '"'],
  [/&lt;/g, '<'],
  [/&gt;/g, '>'],
  [/&amp;/g, '&']
];

export function decodeHtmlEntities(value: any) {
  if (typeof value !== 'string') return value;

  return ENTITIES.reduce((text, [entity, character]) => text.replace(entity, character), value);
}
